import { computed, ref, isRef, watch, warn } from '@vue/composition-api'
import Fuse from 'fuse.js'

export const useFuseSearch = (items, config = {}) => {
  if (!isRef(items)) return warn('List must be a ref')

  const search = ref('')
  const list = ref([])

  const results = computed(() => {
    if (!search.value) return list.value

    const fuse = new Fuse(list.value, {
      ...config,
      shouldSort: false,
      useExtendedSearch: true
    })

    return fuse.search(`'${search.value}`).map(({ item }) => item)
  })

  watch(items, (newItems) => (list.value = newItems), { immediate: true })

  return {
    search,
    results
  }
}
